<template>
	<div>
		<b-overlay :show="isLoading" rounded="sm"> </b-overlay>
		<MembersTable
			:isLoading="isLoading"
			:tableData="allUserRelationships"
			:tableHeaders="userTitles"
			:headerButtonData="{
				title: 'Add Relationship',
				dropdownItems: [
					{ title: 'New Relationship', action: 'new' },
					{ title: 'Link Existing Member', action: 'link' },
				],
			}"
			headerTitle="Relationships"
			@viewClicked="viewClicked"
			@dropdownItemClicked="dropdownItemClicked"
		/>
		<NewRelationshipModal
			:show="showNewRelationshipModal"
			:userData="userData"
			@created="onRelationshipChanged"
			@close="showNewRelationshipModal = false"
		/>
		<UsersModal
			headerTitle="Select Member"
			singleSelect
			:show="showUsersModal"
			:exempted-users="exemptedUsers"
			@viewClicked="memberPicked"
			@close="showUsersModal = false"
		/>
		<LinkRelationshipModal
			:show="showLinkRelationshipModal"
			:userData="userData"
			:linkedUser="linkedUser"
			@linked="onRelationshipChanged"
			@close="showLinkRelationshipModal = false"
		/>
	</div>
</template>
<script>
import MembersTable from '../../MembersTable.vue';
import AppUserManager from '../../../../models/AppUser/AppUserManager';
import { DashboardChildren } from '../../../../routes/routesNames';
import NewRelationshipModal from '../../../../components/Modals/NewRelationshipModal.vue';
import UsersModal from '../../../../components/Modals/UsersModal.vue';
import LinkRelationshipModal from '../../../../components/Modals/LinkRelationshipModal.vue';

export default {
	props: {
		userData: null,
		refresh: false,
	},
	data() {
		return {
			isLoading: false,
			allUserRelationships: [],
			showNewRelationshipModal: false,
			showUsersModal: false,
			showLinkRelationshipModal: false,
			linkedUser: null,
			userTitles: [
				{
					key: 'nameAndPhoto',
					label: 'Name',
					sortable: true,
					tdClass: 'align-middle',
					thStyle: { width: '90%' },
					formatter: (value, key, item) => {
						return item;
					},
					sortByFormatted: (value, key, item) => {
						return item;
					},
				},
				{
					key: 'relationshipStatus',
					label: 'Status',
					tdClass: 'align-middle',
					formatter: (value, key, item) => {
						return item.isPending != null || item.isRequesting != null
							? 'Pending'
							: '';
					},
					sortByFormatted: (value, key, item) => {
						return item.isPending != null || item.isRequesting != null;
					},
				},
				{
					key: 'relationshipType',
					label: 'Relationship',
					sortable: true,
					tdClass: 'align-middle',
					formatter: (value, key, item) => {
						return value.charAt(0).toUpperCase() + value.slice(1);
					},
					sortByFormatted: (value, key, item) => {
						return value.charAt(0).toUpperCase() + value.slice(1);
					},
				},
			],
		};
	},
	computed: {
		exemptedUsers() {
			const linkedUsers = this.allUserRelationships
				.filter((r) => !r.tempUid)
				.map((r) => ({ uid: r.uid }));
			return [{ uid: this.userData.uid }, ...linkedUsers];
		},
	},
	watch: {
		refresh: {
			handler(val) {
				if (val) {
					return this.getUserRelationships();
				}
			},
		},
	},
	methods: {
		viewClicked(item) {
			if (item.tempUid) {
			} else {
				this.$router.push({
					name: DashboardChildren.memberProfile.name,
					params: {
						userData: item,
					},
					query: {
						uid: item.uid,
					},
				});
				this.$forceUpdate();
			}
		},
		dropdownItemClicked(item) {
			if (item.action == 'new') {
				this.showNewRelationshipModal = true;
			} else if (item.action == 'link') {
				this.showUsersModal = true;
			}
		},
		memberPicked(item) {
			this.showUsersModal = false;
			this.linkedUser = item;
			this.showLinkRelationshipModal = true;
		},
		onRelationshipChanged() {
			this.getUserRelationships();
		},
		getUserRelationships() {
			this.isLoading = true;
			AppUserManager.getUserRelationships(this.userData.uid)
				.then((items) => {
					if (items) {
						this.allUserRelationships = items;
					}
					this.isLoading = false;
				})
				.catch(() => {});
		},
	},
	components: {
		MembersTable,
		NewRelationshipModal,
		UsersModal,
		LinkRelationshipModal,
	},
};
</script>
